/* ============================================================================
   LIBUX — <cart-gift-wrap>   ·   VERSION 4

   CAMBIO EN LA V4:
   Se elimina el uso de la propiedad privada "_sin_regalo". El admin de
   Shopify SI muestra las propiedades privadas (el checkout no), asi que
   ensuciaba la orden. Ahora, cuando el cliente desmarca y no queda ninguna
   otra propiedad, se elimina la linea y se vuelve a agregar limpia.
   Se elimina PRIMERO y se agrega despues: al reves, un producto con 1 sola
   unidad de stock haria fallar el segundo agregado por falta de inventario.

   CAMBIO EN LA V3:
   Se elimina la logica de deltas (sumar/restar bolsas) y se reemplaza por
   RECONCILIACION ABSOLUTA: despues de cada cambio, el codigo lee el carrito
   completo, cuenta las unidades marcadas como regalo, y fuerza la linea de
   "Envoltura de Regalo" a ese numero exacto.

   Por que: los deltas se desincronizan si el cliente marca en la ficha y
   luego toca el carrito, si hace clics rapidos, o si elimina un producto.
   La reconciliacion es idempotente: correrla dos veces da el mismo resultado,
   y ademas repara carritos que ya quedaron mal.

   Tambien reconcilia cada vez que se abre el cajon del carrito, para corregir
   descuadres provocados por el propio componente de cantidad del tema.

   Limitaciones de la Ajax Cart API que este codigo maneja:
   - Al enviar "properties" se sobreescribe TODO el objeto -> reenviamos las
     propiedades existentes en cada llamada.
   - No se puede dejar "properties" vacio una vez que tuvo valor -> por eso
     la unica forma de limpiar del todo es recrear la linea del carrito.
   ========================================================================= */

(function () {
  'use strict';

  // Candado global: evita que dos reconciliaciones corran a la vez
  var isReconciling = false;
  var openListenerAttached = false;

  class CartGiftWrap extends HTMLElement {
    constructor() {
      super();
      this.checkbox = this.querySelector('[data-gift-wrap-checkbox]');
      this.messageWrapper = this.querySelector('[data-gift-wrap-message-wrapper]');
      this.messageInput = this.querySelector('[data-gift-wrap-message]');
      this.spinner = this.querySelector('[data-gift-wrap-spinner]');

      this.handleToggle = this.handleToggle.bind(this);
      this.handleMessageChange = this.handleMessageChange.bind(this);
      this.reconcileGiftWrap = this.reconcileGiftWrap.bind(this);
    }

    connectedCallback() {
      if (window.wetheme && window.wetheme.webcomponentRegistry) {
        window.wetheme.webcomponentRegistry.register({ key: 'component-cart-gift-wrap' });
      }

      this.checkbox && this.checkbox.addEventListener('change', this.handleToggle);
      // Solo en 'change' (al salir del campo): guardar en cada tecla dispararia
      // un re-render del drawer y el cliente perderia el foco mientras escribe.
      this.messageInput && this.messageInput.addEventListener('change', this.handleMessageChange);

      // Al abrir el carrito, verificamos que las bolsas cuadren.
      // Se registra una sola vez, no por cada producto.
      if (!openListenerAttached && window.eventBus) {
        openListenerAttached = true;
        var self = this;
        window.eventBus.on('drawer:opened', function () {
          self.reconcileGiftWrap().then(function (changed) {
            if (changed) window.eventBus.emit('render:cart:drawer');
          });
        });
      }
    }

    /* -------------------------------------------------------------- getters */

    get itemIndex() { return parseInt(this.getAttribute('data-item-index'), 10); }
    get hasGiftWrap() { return this.getAttribute('data-has-gift-wrap') === 'true'; }
    get giftWrapVariantId() { return parseInt(this.getAttribute('data-gift-wrap-variant-id'), 10); }
    get giftProp() { return this.getAttribute('data-gift-prop'); }
    get giftValue() { return this.getAttribute('data-gift-value') || 'Sí'; }
    get messageProp() { return this.getAttribute('data-message-prop'); }

    /**
     * Devuelve SIEMPRE un objeto plano { clave: "valor" }.
     * Acepta el array de pares que entrega Liquid o un objeto, y descarta
     * cualquier clave numerica corrupta que haya quedado de versiones previas.
     */
    get existingProperties() {
      var raw;
      try {
        raw = JSON.parse(this.getAttribute('data-item-properties'));
      } catch (e) {
        return {};
      }
      if (!raw) return {};

      var result = {};

      if (Array.isArray(raw)) {
        raw.forEach(function (pair) {
          if (Array.isArray(pair) && pair.length >= 2) {
            result[String(pair[0])] = String(pair[1]);
          }
        });
        return result;
      }

      Object.keys(raw).forEach(function (key) {
        if (/^\d+$/.test(key)) return;
        var value = raw[key];
        if (typeof value !== 'string' && typeof value !== 'number') return;
        result[key] = String(value);
      });
      return result;
    }

    /* ------------------------------------------------------------- handlers */

    async handleToggle() {
      var isChecked = this.checkbox.checked;

      // Feedback inmediato, sin esperar al servidor
      if (this.messageWrapper) this.messageWrapper.hidden = !isChecked;

      var message = isChecked && this.messageInput ? this.messageInput.value : '';
      await this.save(isChecked, message);
    }

    async handleMessageChange() {
      if (!this.checkbox || !this.checkbox.checked) return;
      await this.save(true, this.messageInput.value || '');
    }

    /* ---------------------------------------------------------------- core */

    async save(isGift, message) {
      this.setLoading(true);

      try {
        /* 1. Armar el nuevo objeto de propiedades -------------------------- */
        var props = this.existingProperties;
        delete props[this.giftProp];
        delete props[this.messageProp];
        delete props['_sin_regalo'];   // limpieza de versiones anteriores

        if (isGift) {
          props[this.giftProp] = this.giftValue;
          if (message && message.trim() !== '') {
            props[this.messageProp] = message.trim();
          }
        }

        /* 2. Guardar --------------------------------------------------------
           Si no queda ninguna propiedad, la API no permite vaciar el objeto:
           hay que recrear la linea para que la orden quede limpia.          */
        var updated;
        if (Object.keys(props).length === 0) {
          updated = await this.recreateLineWithoutProperties();
        } else {
          updated = await this.changeLine({ line: this.itemIndex, properties: props });
        }
        if (!updated) throw new Error('No se pudo actualizar la línea del carrito');

        /* 3. Recalcular las bolsas desde cero ------------------------------- */
        await this.reconcileGiftWrap();

        /* 4. Re-renderizar el drawer y el contador -------------------------- */
        if (window.eventBus) window.eventBus.emit('render:cart:drawer');
        this.updateCartCount();

      } catch (error) {
        console.error('[cart-gift-wrap] Error al guardar la opción de regalo:', error);
        // Revertimos la UI para no mentirle al cliente
        if (this.checkbox) this.checkbox.checked = this.hasGiftWrap;
        if (this.messageWrapper) this.messageWrapper.hidden = !this.hasGiftWrap;
      } finally {
        this.setLoading(false);
      }
    }

    /**
     * Elimina la linea y la vuelve a agregar sin ninguna propiedad.
     * Es la unica forma de dejar la orden completamente limpia: la Ajax Cart
     * API no permite vaciar el objeto "properties" una vez que tuvo valor.
     *
     * Se elimina PRIMERO para liberar el inventario. Si se agregara primero,
     * un producto con stock 1 rechazaria la segunda unidad.
     */
    async recreateLineWithoutProperties() {
      var cart = await this.getCart();
      if (!cart || !cart.items) return null;

      var item = cart.items[this.itemIndex - 1];
      if (!item) return null;

      var payload = { id: item.variant_id, quantity: item.quantity };
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        payload.selling_plan = item.selling_plan_allocation.selling_plan.id;
      }

      /* 1. Eliminar la linea original (identificada por su key, no por indice) */
      var removed = await this.changeLine({ id: item.key, quantity: 0 });
      if (!removed) return null;

      /* 2. Volver a agregarla limpia, con un reintento por si acaso */
      var added = await this.addItem(payload);
      if (!added) added = await this.addItem(payload);

      if (!added) {
        console.error('[cart-gift-wrap] No se pudo recrear la línea del carrito.');
      }
      return added;
    }

    /**
     * RECONCILIACION ABSOLUTA.
     * Cuenta las unidades marcadas como regalo y fuerza la linea de envoltura
     * a esa cantidad exacta. No suma ni resta: calcula el numero correcto.
     * Devuelve true si tuvo que corregir algo.
     */
    async reconcileGiftWrap() {
      if (isReconciling) return false;
      isReconciling = true;

      try {
        var cart = await this.getCart();
        if (!cart || !cart.items) return false;

        var wrapId = this.giftWrapVariantId;
        var giftProp = this.giftProp;

        /* Cuantas unidades deberian ir envueltas */
        var target = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id === wrapId) return;          // la envoltura no cuenta
          var props = item.properties || {};
          if (props[giftProp]) target += item.quantity;
        });

        /* Cuantas bolsas hay hoy en el carrito */
        var wrapIndex = cart.items.findIndex(function (item) {
          return item.variant_id === wrapId;
        });
        var current = wrapIndex === -1 ? 0 : cart.items[wrapIndex].quantity;

        if (current === target) return false;              // todo cuadra

        if (wrapIndex === -1) {
          if (target > 0) await this.addToCart(wrapId, target);
        } else {
          // quantity 0 elimina la linea
          await this.changeLine({ line: wrapIndex + 1, quantity: target });
        }

        return true;
      } catch (error) {
        console.error('[cart-gift-wrap] Error al reconciliar las bolsas:', error);
        return false;
      } finally {
        isReconciling = false;
      }
    }

    /* ----------------------------------------------------------------- api */

    async changeLine(payload) {
      var url = (window.routes && window.routes.cart_change_url) ||
                (window.Shopify.routes.root + 'cart/change.js');

      var response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });

      var text = await response.text();
      if (!text) return null;

      var json = JSON.parse(text);
      if (json.errors) {
        console.error('[cart-gift-wrap] Cart API:', json.errors);
        return null;
      }
      return json;
    }

    async addToCart(variantId, quantity) {
      return this.addItem({ id: variantId, quantity: quantity });
    }

    async addItem(itemPayload) {
      try {
        var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [itemPayload] })
        });
        if (!response.ok) {
          console.error('[cart-gift-wrap] cart/add.js respondió', response.status);
          return null;
        }
        return await response.json();
      } catch (error) {
        console.error('[cart-gift-wrap] Error al agregar al carrito:', error);
        return null;
      }
    }

    async getCart() {
      try {
        var response = await fetch(window.Shopify.routes.root + 'cart.js');
        return await response.json();
      } catch (error) {
        console.error('[cart-gift-wrap] Error al leer el carrito:', error);
        return null;
      }
    }

    updateCartCount() {
      if (!window.wetheme || !window.wetheme.updateCartCount) return;
      this.getCart().then(function (cart) {
        if (cart) window.wetheme.updateCartCount(cart);
      });
    }

    /* ------------------------------------------------------------------ ui */

    setLoading(state) {
      this.classList.toggle('is-loading', state);
      if (this.spinner) this.spinner.hidden = !state;
      if (this.checkbox) this.checkbox.disabled = state;
    }
  }

  customElements.define('cart-gift-wrap', CartGiftWrap);
})();